import { Component, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';


import { MateriaisService } from '../../../../providers/materiais-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';

declare var jsPDF: any;

@Component({
    selector: 'page-alienacao-bens-imoveis',
    templateUrl: 'alienacao-bens-imoveis.html',
    providers: [
        MateriaisService
    ]
})
export class AlienacaoBensImoveisPage extends ModulosController {
    listaDados: any = [];
    loading: boolean = true;
    idSecaoPagina: string = "166";
    tiposArquivosAceitos: string = "application/xls";
    dadosImportados: any[];

    private myDatePickerPublicacao: IMyDpOptions;
    private myDatePickerExtrato: IMyDpOptions;
    private placeholder: string = 'Informe a Data';

    page1: number = 1;

    relatorioParaAdicionar: any = {
        "id": "",
        "item": "",
        "nmLeiAlienacao": "",
        "dtPublicacaoLeiDOE": "",
        "alinea": "",
        "dtPublicacaoExtDOE": "",
        "nmProcessoLicitatorioDispensa": "",
        "nmTombamento": "",
        "valorAvaliacao": "",
        "valorAlienacao": "",
        "idModuloAnalise": 0
    }

    objetoEdit: any = null;
    listEdit: any = [];
    analise: any = null;

    @ViewChild('inputFileCM')
    inputFileCMVar: ElementRef;

    selecionarTodosChecked = false;

    totalValorAvaliacao = 0;
    totalValorAlienacao = 0;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public materiaisService: MateriaisService,
        private fileService: FileService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.analise = this.navParams.get('analise');

        this.carregarDados();
        this.setModuloId(13);

        this.myDatePickerPublicacao = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false
            //disableUntil: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() - 1 }
        };


        this.myDatePickerExtrato = {
            dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
            monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
            dateFormat: 'dd/mm/yyyy',
            todayBtnTxt: 'Hoje',
            firstDayOfWeek: 'su',
            disableWeekends: false,
            editableDateField: true,
            openSelectorOnInputClick: true,
            showClearDateBtn: false,
            openSelectorTopOfInput: true,
            showSelectorArrow: false
            //disableUntil: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() - 1 }
        };

    }

    carregarDados() {
        this.materiaisService.listarAlienacoes(this.idSecaoPagina).subscribe(data => {
            this.listaDados = data;
            this.totalizarValores();
            this.selecionarTodosChecked = false;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });

    }

    fileChange(event) {
        this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
            if (callback) {                
                this.loading = true;
                this.fileService.cargaAlienacoes(event, this.idSecaoPagina).subscribe(data => {
                    this.inputFileCMVar.nativeElement.value = "";                    
                    this.dadosImportados = data;

                    for (let j = 0; j < this.dadosImportados.length; j++) {
                        this.listaDados.push(this.dadosImportados[j]);                        
                    }

                    this.totalizarValores();
                    
                    this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");         
                    this.loading = false;
          
                  }, error => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
                    this.loading = false;
                });
            } else {
                this.inputFileCMVar.nativeElement.value = "";
            }
        });
    }

    downloadDoModelo() {
        this.fileService.downloadModeloCargaGestaoMateriais(this.idSecaoPagina);
    }

    adicionarRelatorio() {

        if (this.relatorioParaAdicionar.item != '' &&
            this.relatorioParaAdicionar.nmLeiAlienacao != '' &&
            this.relatorioParaAdicionar.dtPublicacaoLeiDOE != '' &&
            this.relatorioParaAdicionar.alinea != '' &&
            this.relatorioParaAdicionar.dtPublicacaoExtDOE != '' &&
            this.relatorioParaAdicionar.nmProcessoLicitatorioDispensa != '' &&
            this.relatorioParaAdicionar.nmTombamento != '' &&
            this.relatorioParaAdicionar.valorAvaliacao != '' &&
            this.relatorioParaAdicionar.valorAlienacao != '') {

            let relatorioNovo = {
                "id": 0,
                "item": this.relatorioParaAdicionar.item,
                "nmLeiAlienacao": this.relatorioParaAdicionar.nmLeiAlienacao,
                "dtPublicacaoLeiDOE": this.relatorioParaAdicionar.dtPublicacaoLeiDOE,
                "alinea": this.relatorioParaAdicionar.alinea,
                "dtPublicacaoExtDOE": this.relatorioParaAdicionar.dtPublicacaoExtDOE,
                "nmProcessoLicitatorioDispensa": this.relatorioParaAdicionar.nmProcessoLicitatorioDispensa,
                "nmTombamento": this.relatorioParaAdicionar.nmTombamento,
                "valorAvaliacao": this.relatorioParaAdicionar.valorAvaliacao,
                "valorAlienacao": this.relatorioParaAdicionar.valorAlienacao,
                "idModuloAnalise": 0
            }

            if (this.objetoEdit) {
                let index = this.listaDados.indexOf(this.objetoEdit);
                this.listaDados.splice(index, 1);

                relatorioNovo.id = this.objetoEdit.id;

                this.listEdit.push(this.objetoEdit);
            }

            this.listaDados.push(relatorioNovo);
            this.totalizarValores();
            this.objetoEdit = null;

            this.selecionarTodosChecked = false;

            this.relatorioParaAdicionar.item = '';
            this.relatorioParaAdicionar.nmLeiAlienacao = '';
            this.relatorioParaAdicionar.dtPublicacaoLeiDOE = null;
            this.relatorioParaAdicionar.alinea = '';
            this.relatorioParaAdicionar.dtPublicacaoExtDOE = null;
            this.relatorioParaAdicionar.nmProcessoLicitatorioDispensa = null;
            this.relatorioParaAdicionar.nmTombamento = '';
            this.relatorioParaAdicionar.valorAvaliacao = ''
            this.relatorioParaAdicionar.valorAlienacao = '';

            this.salvar(true);
        }
        else {
            this.alertService.mostraAlerta("", "Verifique os campos do formulário não preenchidos.");
            return;
        }
    }

    remover(item, edit) {

        if (!edit) {
            this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
                if (callback) {
                    let index = this.listaDados.indexOf(item);
                    this.listaDados.splice(index, 1);

                    if (item.id != "0") {
                        this.materiaisService.deletarAlienacao(item.id, this.idSecaoPagina).subscribe(data => {
                        }, error => {
                            this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro: " + error);
                            this.carregarDados();
                        });
                    }
                }
            });
        } else {
            let index = this.listaDados.indexOf(item);
            this.listaDados.splice(index, 1);

            if (item.id != "0") {
                this.materiaisService.deletarAlienacao(item.id, this.idSecaoPagina).subscribe(data => {
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro: " + error);
                    this.carregarDados();
                });
            }
        }

    }

    excluirSelecionados(){

        let qtdeSelecionados = 0; 
        this.listaDados.forEach(item => qtdeSelecionados += item.checked);
        
        if(qtdeSelecionados == 0) {
            this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
            return;
        }
    
        let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");
    
        this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto, 
            "Deseja continuar com a exclusão de " 
                + registrosTexto + "<br/>" 
                + "Após a exclusão, os registros serão recarregados. Certifique-se de salvar possíveis alterações antes de prosseguir!", 
            callback => {            
                if (callback) {
                    this.loading = true;
                                        
                    let listaId = this.listaDados
                        .filter(item => item.checked)
                        .map(item => item.id);
                    
                    this.materiaisService.deletarAlienacaoLista(listaId, this.idSecaoPagina).subscribe(data => {
                        this.loading = false;
                        this.carregarDados();
                        this.alertService.mostraAlerta("", data.mensagem);
                    }, error => {
                        this.loading = false;
                        this.carregarDados();
                        this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
                    });
                }
            }
        );        
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaMateriais() {
        this.menuService.redirecionarPagina(this.materiaisService.obterIdPaginaMateriais());
    }

    salvar(add) {
        this.loading = true;
        // this.listEdit.forEach(item => {
        //     this.remover(item.id, true);
        // });

        this.listEdit = [];

        this.materiaisService.salvarAlienacoes(this.listaDados, this.idSecaoPagina).subscribe(data => {

            if (!add) {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
              } else {
                console.log("Salvo com sucesso...");
              }

            this.carregarDados();
            this.loading = false;
        }, error => {

            if (!add) {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
              } else {
                console.log("Ocorreu um erro ao salvar...");
              }
            this.loading = false;
        })
    }

    finalizar() {
        this.loading = true;

        this.listEdit.forEach(item => {
            this.remover(item.id, true);
        });

        this.listEdit = [];

        if (this.listaDados) {
            this.materiaisService.finalizarAlienacoes(this.listaDados, this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                this.voltarParaMateriais();
                this.loading = false;
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
                this.loading = false;
            });
        }
    }

    onDatePickerDataPub(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.relatorioParaAdicionar.dtPublicacaoLeiDOE = null;
        }
        else {
            this.relatorioParaAdicionar.dtPublicacaoLeiDOE = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }

    onDatePickerExtrato(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.relatorioParaAdicionar.dtPublicacaoExtDOE = null;
        }
        else {
            this.relatorioParaAdicionar.dtPublicacaoExtDOE = new Date(event.jsdate).toLocaleDateString('pt-br');
        }
    }

    editar(item) {
        this.relatorioParaAdicionar.item = item.item;
        this.relatorioParaAdicionar.nmLeiAlienacao = item.nmLeiAlienacao;
        this.relatorioParaAdicionar.dtPublicacaoLeiDOE = item.dtPublicacaoLeiDOE;
        this.relatorioParaAdicionar.alinea = item.alinea;
        this.relatorioParaAdicionar.dtPublicacaoExtDOE = item.dtPublicacaoExtDOE;
        this.relatorioParaAdicionar.nmProcessoLicitatorioDispensa = item.nmProcessoLicitatorioDispensa;
        this.relatorioParaAdicionar.nmTombamento = item.nmTombamento;
        this.relatorioParaAdicionar.valorAvaliacao = item.valorAvaliacao;
        this.relatorioParaAdicionar.valorAlienacao = item.valorAlienacao;

        this.objetoEdit = item;
    }

    printData() {

        var doc = new jsPDF("l");

        var totalPagesExp = "{total_pages_count_string}";

        this.materiaisService.listarAlienacoes(this.idSecaoPagina).subscribe(listaCompleta => {
            var pageContent = function (data) {
                // HEADER
                doc.setFontSize(20);
                doc.setTextColor(40);
                doc.setFontStyle('normal');

                doc.text("Alienações Patrimoniais dos Bens Imóveis", data.settings.margin.left + 15, 22);

                // FOOTER
                var str = "Page " + data.pageCount;
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    str = str + " of " + totalPagesExp;
                }
                doc.setFontSize(10);
                doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
            };

            var columns = [
                { title: "Item", dataKey: "item" },
                { title: "Lei", dataKey: "lei" },
                { title: "Data Public.", dataKey: "doe" },
                { title: "Nº Processo", dataKey: "processo" },
                { title: "Fundamentação", dataKey: "fundamento" },
                { title: "Public. Extrato", dataKey: "extrato" },
                { title: "Nº Tombamento", dataKey: "tombamento" },
                { title: "Valor Avaliação", dataKey: "avaliacao" },
                { title: "Valor Alienação", dataKey: "alienacao" }
            ];

            let rows = [];

            listaCompleta.forEach(element => {

                var item = {
                    "item": element.item != null ? element.item : "",
                    "lei": element.nmLeiAlienacao != null ? element.nmLeiAlienacao : "",
                    "doe": element.dtPublicacaoLeiDOE != null ? element.dtPublicacaoLeiDOE : "",
                    "processo": element.nmProcessoLicitatorioDispensa != null ? element.nmProcessoLicitatorioDispensa : "",
                    "fundamento": element.alinea != null ? element.alinea : "",
                    "extrato": element.dtPublicacaoExtDOE != null ? element.dtPublicacaoExtDOE : "",
                    "tombamento": element.nmTombamento != null ? element.nmTombamento : "",
                    "avaliacao": element.valorAvaliacao != null ? this.formatarValorNumerico(element.valorAvaliacao) : "",
                    "alienacao": element.valorAlienacao != null ? this.formatarValorNumerico(element.valorAlienacao) : ""
                };

                rows.push(item);
            });

            doc.autoTable(columns, rows, {
                //     theme: 'grid',
                //     addPageContent: pageContent,
                //     margin: { top: 30 },
                //     styles: {
                //         overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
                //         columnWidth: 'auto'
                //     }
                // });

                theme: 'grid',
                addPageContent: pageContent,
                margin: {
                    top: 30,
                    left: 5
                },
                styles: {
                    overflow: 'linebreak',
                    columnWidth: 'wrap',
                    fontSize: 9
                },
                columnStyles: {
                    text: { columnWidth: 'auto' },
                    item: { columnWidth: 40 },
                    lei: { columnWidth: 25 },
                    doe: { columnWidth: 25 },
                    processo: { columnWidth: 25 },
                    fundamento: { columnWidth: 30 },
                    extrato: { columnWidth: 25 },
                    tombamento: { columnWidth: 25 },
                    avaliacao: { columnWidth: 25 },
                    alienacao: { columnWidth: 25 }
                }
            });

            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp);
            }

            doc.save('alienacao_bens_imoveis.pdf');
        });
    }

    selecionarTodos(){
        setTimeout(()=>{
            this.listaDados.forEach(
                item => item.checked = this.selecionarTodosChecked);            
        });
    }
    
    selecionarItem(){
        const totalItems = this.listaDados.length;
        let checked = 0;
        this.listaDados.map(obj => {
            if (obj.checked) checked++;
        });
        this.selecionarTodosChecked = checked == totalItems;
    }

    totalizarValores() {
        this.totalValorAvaliacao = 0;
        this.totalValorAlienacao = 0;
    
        this.listaDados.forEach(element => {
            this.totalValorAvaliacao += element.valorAvaliacao;
            this.totalValorAlienacao += element.valorAlienacao;
        });    
      }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/materiais/alienacao-bens-imoveis/alienacao-bens-imoveis.ts